import { isIdXboxGameInformationUgcFormValid } from "../../../../helpers/formValidation";
import { GameInformationUgcDataType, SubFormsDataTypes } from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const UgcDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const ugcData = data as GameInformationUgcDataType;
    if (!ugcData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationUgcFormValid(ugcData);
    return { result: validSchema };
  },
};
